<mat-form-field class="w-100">
	<input
		*ngIf="readonly"
		matInput
		readonly
		placeholder="Service"
		[value]="serviceType"
		[required]="required"
	/>
	<mat-select
		*ngIf="!readonly"
		[required]="required"
		[formControl]="serviceType"
		[compareWith]="idComparer"
		(selectionChange)="optionSelected.emit($event.value)"
		placeholder="Service"
	>
		<mat-option>--</mat-option>
		<mat-option
			*ngFor="let service of serviceTypes$ | async"
			[value]="service"
		>
			{{ displayDescription(service) }}
		</mat-option>
	</mat-select>
	<mat-error>Required</mat-error>
</mat-form-field>
